import { useState, useMemo } from "react";
import { NumberField, Stat, ToolShell } from "./parts";
import { inr } from "@/lib/format";

export function TdsCalculator() {
  const [value, setValue] = useState(6000000);

  const { applicable, tds, net } = useMemo(() => {
    const applicable = value >= 5000000;
    const tds = applicable ? value * 0.01 : 0;
    return { applicable, tds, net: value - tds };
  }, [value]);

  return (
    <ToolShell title="TDS on Property" desc="Under Section 194-IA, the buyer must deduct 1% TDS on properties valued at ₹50 lakh or more and deposit it via Form 26QB.">
      <div className="grid gap-10 lg:grid-cols-2">
        <div className="space-y-8">
          <NumberField label="Property Sale Value" value={value} onChange={setValue} min={1000000} max={200000000} step={100000} prefix="₹" testid="tds-value" />
          <div className={`border p-5 ${applicable ? "border-cyan/40" : "border-border"} bg-background`} data-testid="tds-status">
            <p className="font-mono text-xs uppercase tracking-widest text-muted-foreground">Status</p>
            <p className={`mt-2 font-mono text-sm ${applicable ? "text-cyan" : "text-foreground"}`}>
              {applicable ? "TDS @ 1% is applicable" : "Below ₹50L — TDS not applicable"}
            </p>
          </div>
        </div>
        <div className="space-y-5">
          <Stat label="TDS to Deduct (1%)" value={inr(tds)} highlight testid="tds-result" />
          <Stat label="Net Amount to Seller" value={inr(net)} />
          <p className="border border-border bg-background p-4 font-mono text-xs leading-relaxed text-muted-foreground">
            Note: If the seller does not have a PAN, TDS is deducted at 20%. TDS must be deposited within 30 days from the end of the month of deduction.
          </p>
        </div>
      </div>
    </ToolShell>
  );
}
